interface Store {
    uuid: string;
    name: string;
    latitude: number;
    longitude: number;
}

interface ClosestStore extends Store {
    distance: number;
}

const LIMIT = 20; // in meters

export const getClosestStore = async (
    userLat: number,
    userLng: number,
    stores: Store[],
    excludeUuids: string[],
): Promise<ClosestStore | null> => {
    const { default: L } = await import('leaflet');

    const userLocation = L.latLng(userLat, userLng);
    const filtered = stores.filter((store) => !excludeUuids.includes(store.uuid));

    const closest = filtered.reduce<ClosestStore | null>((acc, store) => {
        const storeLocation = L.latLng(store.latitude, store.longitude);
        // in meters
        const distance = userLocation.distanceTo(storeLocation);
        if (!acc || distance < acc.distance) return { ...store, distance };
        return acc;
    }, null);

    return closest && closest.distance <= LIMIT ? closest : null;
};
